import { useEffect, useState } from 'react';
import {  ShowLoader } from 'GlobalFunctions';
import SubscriptionUpdateCard from './Utils/SubscriptionUpdateCard';

export default function SubscriptionCheckout() {

    const [subscriptionCode, setSubscriptionCode] = useState<string | null>(null);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const subParam = urlParams.get('subscription');
        if (subParam) {
            setSubscriptionCode(subParam);
        }
    }, []);
    


    return (
        <>  
            {subscriptionCode ? (
                <>
                    <SubscriptionUpdateCard 
                        subscriptionCode={subscriptionCode}
                        ShowLoader={ShowLoader}
                    />
                </>
            ) : null}
            
        </>
    )
}
